import React from 'react';
import CadastroPdv from './CadastroPdv';
import { cadastrarPdv, atualizarModulosLicenca } from '../services/api';
import { useNavigate } from 'react-router-dom';

const NovoPDV = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data, token, { itensModulos = [] } = {}) => {
    try {
      const resp = await cadastrarPdv(data, token);
      const novoId = resp?.data?.id;
      if (novoId && itensModulos.length > 0) {
        await atualizarModulosLicenca('ZenPDV', novoId, itensModulos, token);
      }
      alert('PDV cadastrado com sucesso!');
      navigate('/licenciamento/zenpdv');
    } catch (err) {
      const errData = err?.response?.data;

      if (typeof errData === 'string') {
        alert(errData);
        return;
      }

      const message =
        errData?.message ||
        (errData?.errors && Object.values(errData.errors).flat().join('\n')) ||
        err.message ||
        'Erro ao salvar PDV.';

      alert(message);
      console.error(err);
    }
  };

  return (
    <CadastroPdv onSubmit={handleSubmit} token={token} />
  );
};

export default NovoPDV;
